'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiDialogTitle, {
  type DialogTitleTypeMap as MuiDialogTitleTypeMap,
} from '@mui/material/DialogTitle';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type DialogTitleTypeMap<
  P = CustomProps,
  D extends ElementType = MuiDialogTitleTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiDialogTitleTypeMap['props'], ExcludedMuiProps> & P;
};

export type DialogTitleProps<
  D extends ElementType = MuiDialogTitleTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiDialogTitleTypeMap<P, D>, D>;

const DialogTitleComponent = (
  props: DialogTitleProps,
  ref: Ref<HTMLSpanElement>
) => {
  return <MuiDialogTitle {...props} ref={ref} />;
};

DialogTitleComponent.displayName = 'DialogTitle';

export const DialogTitle = forwardRef(
  DialogTitleComponent
) as OverridableComponent<DialogTitleTypeMap>;
